module.exports = __webpack_public_path__ + "static/select-42122816ff7853ac83c031a024f28d50.png";